import { useState, useEffect, useCallback, useRef } from 'react'
import ChatHead from '@components/chat/components/ChatHead'
import Message from '@components/chat/components/ListItemMessage'
import MessageForm from '@components/chat/components/MessageForm'
import ListOut from '@components/shared/ListOut'
import NavLinkButton from '@components/shared/NavLinkButton'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'

import { get } from '@api/apiFetcher'

const PER_PAGE = 10
const API = '/api/chat/:id/messages/:type/:skip/:limit'

import styles from '@components/chat/styles/ChatList.module.css'

const ChatMessages = ({ user, chat, closeChat, closeWindow }) => {
    const [messages, setMessages] = useState([])
    const [done, setDone] = useState(false)
    const isSystem = Boolean(chat.system)
    const ref = useRef(null)

    const getMessages = useCallback(() => {
        const path = API
            .replace(':id', chat._id)
            .replace(':type', isSystem
                ? 'system'
                : 'user')
            .replace(':skip', messages.length)
            .replace(':limit', PER_PAGE)

        get({ path, auth: user?.token })
            .then(res => {
                if (res.length < PER_PAGE) setDone(true)
                setMessages(res.concat(messages))
            })

    }, [chat?._id, messages.length])

    const scrollToBottom = (force) => {
        if (messages.length <= PER_PAGE || force) {
            if (!ref.current) return
            const list = ref.current
            list.scrollTop = list.scrollHeight
        }
    }

    const showSentMessage = useCallback((res) => {
        if (res.message) {
            setMessages(messages.concat(res.message))
            scrollToBottom(true)
        }
    }, [messages.length])

    useEffect(getMessages, [])
    useEffect(scrollToBottom, [messages.length])

    const starsze = useT('Starsze wiadomości')

    return <>
        <ChatHead
            icon={<span onClick={closeChat} style={{cursor:'pointer'}}><Icon>arrow_back</Icon></span>}
            title={chat.topic}
            onClose={closeWindow} />


        <div className={styles.list} ref={ref}>
            { !done &&
                <div><br/><NavLinkButton color="blue" onClick={getMessages}>
                    {starsze}</NavLinkButton><br/></div> }

            <ListOut id="_id" items={messages} Component={Message}
                userId={user?._id} chat={chat} />
        </div>

        <br/>
        { !isSystem &&
            <MessageForm user={user} chat={chat}
                showSentMessage={showSentMessage} /> }
    </>
}

export default ChatMessages